
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class BodyConfigAddLayoutComponent extends Vue {
  addLayoutDialog: boolean = false
  name: string = ""
  layout: Array<number> = []
  error: string = ""

  save(save?: boolean) {
    this.error = ""
    if (save) {
      if (!this.name) {
        this.error = "Please enter a name."
        return
      }
      if (this.layout.length === 0 || this.layout[0] == 0) {
        this.error = "Please add at least one row and column"
        return
      }
      
      this.$emit("save", {
        name: this.name,
        config: this.layout.map((rowCols) => {
          let row = new Array()
          for (let i = 0; i < rowCols; i++) {
            row.push({name: ""})
          }
          return row
        })
      })
    }
    this.name = ""
    this.layout = []
    this.addLayoutDialog = false
  }
}
